import React from 'react'
import { DotLoading } from 'antd-mobile'

export default function Loading() {
    return (
        <DotLoading />
    )
}
